<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Cadastrar nova senha</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas apenas para analisarmos o seu perfil
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
          </div>        
        </div>
        <social-network/>
      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form">
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Nova senha</h2>
            <span class="text">Cadastre sua senha</span>
            <form @submit.prevent="setNewPassword">
              <div class="form-group text-left">
                <label for="password">Nova senha</label>
                <password-field v-model="password"/>
              </div>
              <button class="btn btn-lg btn-primary">Cadastrar senha</button>
            </form>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";
  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      //background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }
  }
</style>

<script>
import ApiClient from '@/utils/api-client'
import SocialNetwork from '@/components/SocialNetwork'
import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      password: ''
    }
  },
  components: {
    SocialNetwork, PasswordField
  },
  methods: {
    setNewPassword: function() {
      const query = this.$route.query
      ApiClient.put('update-password', {data: {email: query.email, token: query.token, password: this.password}})
        .then(() => {          
          this.$router.push("/login")
          this.$Notify.info('Sua senha foi atualizada com sucesso.')
        })
        .catch(error => {
          const errorMessages = error.response.data.errors.map(error => error.detail)
          this.$Notify.error(ArrayHelper.toSentence(errorMessages))
        })
    },
    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/nova-senha',
        title: 'NovaSenha',
      })
    },
  },
  async created() {
    //tagueamento GA
    await this.taggingGA();
  }
}
</script>



// WEBPACK FOOTER //
// src/views/NovaSenha.vue